import * as THREE from 'three';
import getChromaKeyMaterial from './chromakey/ChromaKeyMaterial';
import { loadImageAsync } from '../utils/AssetLoader';

export default class VideoPlane {
    constructor(width, height, url, onVideoEnd, imageUrl = null, chromaColor = null, roomId = null, secneHotspotId = null) {
        if (typeof (width) !== 'number' || typeof (height) !== 'number') {
            throw new Error('width and height must be numbers!');
        }
        this.addToScene = this.addToScene.bind(this);
        this.removeFromScene = this.removeFromScene.bind(this);
        this.setTransform = this.setTransform.bind(this);
        this.setPosition = this.setPosition.bind(this);
        this.setRotation = this.setRotation.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.end = this.end.bind(this);
        this.isPlaying = this.isPlaying.bind(this);
        this.isVisible = this.isVisible.bind(this);
        this.roomId = roomId
        this.imageUrl = imageUrl;
        this.secneHotspotId = secneHotspotId;
        this.image = null;
        if (imageUrl) {
            const imageGeometry = new THREE.PlaneGeometry(1, 1);
            const imageMaterial = new THREE.MeshBasicMaterial();
            this.image = new THREE.Mesh(imageGeometry, imageMaterial);
            this.image.visible = false;
            loadImageAsync(
                imageUrl,
                (image) => {
                    this.image.material.map = image;
                    this.image.material.needsUpdate = true;
                    this.image.material.transparent = true;
                    this.image.visible = true;
                },
                null,
                (error) => {
                    console.log("error: " + error + ", loading image with url: " + url);
                },
                roomId
            );
        }

        this.onVideoEnd = onVideoEnd;
        this.video = document.createElement('video');
        this.video.src = url;
        this.video.crossOrigin = 'anonymous';
        this.video.setAttribute('webkit-playsinline', '');
        this.video.setAttribute('playsinline', '');
        this.video.currentTime = 1;
        this.video.load();
        this.video.addEventListener('ended', this.end, false);
        const texture = new THREE.VideoTexture(this.video);
        texture.minFilter = THREE.LinearFilter;
        texture.magFilter = THREE.LinearFilter;
        texture.format = THREE.RGBFormat;

        const geometry = new THREE.PlaneGeometry(width, height);
        const material = chromaColor === null ? new THREE.MeshBasicMaterial({ side: THREE.FrontSide }) : getChromaKeyMaterial(texture, chromaColor);
        material.map = texture;
        material.needsUpdate = true;
        this.plane = new THREE.Mesh(geometry, material);
        this.plane.visible = false;
    }

    addToScene(scene) {
        scene.add(this.plane);
        if (this.imageUrl) {
            scene.add(this.image);
        }
    }

    removeFromScene(scene) {
        scene.remove(this.plane);
        if (this.imageUrl) {
            scene.remove(this.image);
            this.image = null;
        }
        this.plane = null;
        this.pause();
        this.video = null;
    }

    setTransform(transform, imageTransform = null) {
        this.plane.matrix = transform;
        this.plane.matrix.decompose(this.plane.position, this.plane.quaternion, this.plane.scale);

        if (this.imageUrl) {
            this.image.matrix = imageTransform;
            this.image.matrix.decompose(this.image.position, this.image.quaternion, this.image.scale);
        }

        console.log('roomid ',this.roomId ,this.secneHotspotId,  this.video.src);
        

        if (this.video.src.includes('LOOP_VERTICAL')) {
            switch (this.roomId) {
                // view-9
                case '60db66eb37950a94f897bfb6':
                    switch (this.secneHotspotId) {
                        // center
                        case '6230fc1d4e0a1c2640b17fc2':
                            this.setPosition(5.55, 2.48, -5.380);
                            this.setRotation(3.152, -2.2, 3.15);
                            this.setScale(0.0074, 0.0125, 1)
                            this.showInSceneVideo();
                            break;
                        // left
                        case '623acbff1fe3baec4183d1c9':
                            this.setPosition(5.55, 2.500, -6.740);
                            this.setRotation(0, 0.338, 0);
                            this.setScale(0.007, 0.015, 1)
                            this.showInSceneVideo();
                            break;
                        // right
                        case '623acbff1fe3baec4183d1ca':
                            this.setPosition(5.55, 2.780, -4.210);
                            this.setRotation(0, -1.712, 0);
                            this.setScale(0.007, 0.012, 1)
                            this.showInSceneVideo();
                            break;
                    }
                    break;
                // view-8
                case '60db66d637950a94f897bfb5':
                    switch (this.secneHotspotId) {
                        // center
                        case '623116ea15c74855e609adfb':
                            this.setPosition(3.93, 2.938, 7.900);
                            this.setRotation(3.071, -0.699, -3.16);
                            this.setScale(0.0084, 0.0141, 1)
                            this.showInSceneVideo();
                            break;
                        // left
                        case '623ad5e8d6c4aea4607792ff':
                            this.setPosition(3.93, 2.358, 6.420);
                            this.setRotation(0, -1.173, 0);
                            this.setScale(0.008, 0.014, 1)
                            this.showInSceneVideo();
                            break;
                        // right
                        case '623ad5e8d6c4aea460779300':
                            this.setPosition(2.570, 3.158, 7.600);
                            this.setRotation(3.071, 0.231, -3.16);
                            this.setScale(0.008, 0.013, 1)
                            this.showInSceneVideo();
                            break;
                    }
                    break;
                // view-7
                case '60db66c1c584ff71d1029bec':
                    switch (this.secneHotspotId) {
                        // center
                        case '6234da96756cb03ff958d592':
                            this.setPosition(-6.17, 1.81, 3.56);
                            this.setRotation(0, 2.15, 0);
                            this.setScale(0.000265, 0.00056, 1)
                            this.showInSceneVideo();
                            break;
                        // left
                        case '623adad2d9db4c9fd4371acf':
                            this.setPosition(-6.170, 1.700, 4.130);
                            this.setRotation(-3.142, -0.438, -3.142);
                            this.setScale(0.007, 0.01, 1)
                            this.showInSceneVideo();
                            break;
                        // right
                        case '623adad2d9db4c9fd4371ad0':
                            this.setPosition(-8.690, 2.870, 3.890);
                            this.setRotation(-3.142, 1.672, -3.142);
                            this.setScale(0.007, 0.012, 1)
                            this.showInSceneVideo();
                            break;
                    }
                    break;
                // experience-area-2
                case '6213f2ad0b6a1d285d429e85':
                    switch (this.secneHotspotId) {
                        // center
                        case '623ae102de316dac70a412c6':
                            this.setPosition(-3.970, 3.160, 9.060);
                            this.setRotation(-3.142, 0.992, -3.142);
                            this.setScale(0.009, 0.016, 1)
                            this.showInSceneVideo();
                            break;
                        // left
                        case '623ae102de316dac70a412c7':
                            this.setPosition(-1.860, 1.740, 6.150);
                            this.setRotation(3.141, -0.378, 3.141);
                            this.setScale(0.006, 0.01, 1)
                            this.showInSceneVideo();
                            break;
                    }
                    break;
            }
        }
        // experience-area
        if ((this.roomId === '60db676e37950a94f897bfb7') && this.video.src.includes('56626Vacheron-Constantin_Contenplative_Making_of_American_1921.mp4')) {
            this.setPosition(-9.640, 0.720, 2.710);
            this.setRotation(3.172, 0.557, 3.112);
            this.setScale(0.0392, 0.013, 1)
            this.showInSceneVideo(true)
        }
        // experience-area-3
        if (this.roomId === '60db68cec584ff71d1029bf4') {
            if (this.video.src.includes('54868Vacheron-Constantin_Benjamin-Clementine.mp4')) {
                this.setPosition(-1.250, 0.010, 8.990);
                this.setRotation(-3.161, -0.573, 3.122);
                this.setScale(0.0328, 0.0158, 1)
                this.showInSceneVideo(true)
            }

            if (this.video.src.includes('AC_Pop_3_models.mp4')) {
                this.setPosition(0.95, 0.29, 9);
                this.setRotation(0, 3.18, 0);
                this.setScale(0.00368, 0.0057, 1)
                this.showInSceneVideo(true)
            }

        }
        // exclusive-area-3
        if (this.roomId === '60db68cec584ff71d1029bf4') {
            if (this.video.src.includes('10076VAC_Pop_3_models.mp4')) {
                this.setPosition(0.4574, 0.212, 8.3);
                this.setRotation(-0.0175, 3.85, -0.01);
                this.setScale(0.00412, 0.0042, 1)
                this.showInSceneVideo(true)
            }
        }

        // watchmaker-area
        if ((this.roomId === '60db692537950a94f897bfbe') && this.video.src.includes('62264VAC_Pop_3_models.mp4')) {
            this.setPosition(-8.300, 0.110, 8.150);
            this.setRotation(-3.121, 1.317, 3.122);
            this.setScale(0.0135, 0.0094, 1)
            this.showInSceneVideo(true)
        }
        // sales-area-3
        if ((this.roomId === '608b35849ab97c255a2aabad')) {
            if (this.video.src.includes('59801VAC_Pop_3_models.mp4')) {
                this.setPosition(-7.420, 0.175, 0.25);
                this.setRotation(-3.112, 1.54, 3.112);
                this.setScale(0.476, 0.27, 1)
                this.showInSceneVideo(true)

            }
            if (this.video.src.includes('44147VAC_Pop_3_models.mp4')) {
                this.setPosition(-7.930, 0.190, 0.280);
                this.setRotation(0, 1.525, 0);
                this.setScale(0.002, 0.002, 1)
                this.showInSceneVideo(true)
            }
        }
        // sales-area-3-A
        if ((this.roomId === '6213f75a0b6a1d285d429edb')) {
            console.log('VideoPlane ==> ', this.roomId, '/video: ', this.video.src)
            if (this.video.src.includes('23196VAC_Pop_3_models.mp4')) {
                this.setPosition(-7.07, 0.19, -3.090);
                this.setRotation(0, 0.59, 0);
                this.setScale(0.545, 0.324, 1)
                this.showInSceneVideo(true)
            }
        }
        // watchmaker-area
        if ((this.roomId === '60db692537950a94f897bfbe')) {
            if (this.video.src.includes('2264VAC_Pop_3_models.mp4')) {
                this.setPosition(-7.060, 0.21, 7.650);
                this.setRotation(0, 1.555, 0);
                this.setScale(0.56, 0.31, 1)
                this.showInSceneVideo(true)
            }
        }
        // view-5-a
        if ((this.roomId === '6213f05c0b6a1d285d429e7c')) {
            if (this.video.src.includes('Engraver_2149413.mp4')) {
                this.setPosition(-5.970, -2.420, 4.820);
                this.setRotation(-1.632, 1.127, 1.612);
                this.setScale(0.004, 0.003, 1)
                this.showInSceneVideo(true)
            }
            if (this.video.src.includes('Enameler_2149387.mp4')) {
                this.setPosition(-4.670, -1.91, -1.900);
                this.setRotation(-1.602, 1.127, 1.612);
                this.setScale(0.008, 0.006, 1)
                this.showInSceneVideo(true)
            }
        }
        // view-5-c
        if ((this.roomId === '6213f0830b6a1d285d429e7e')) {
            if (this.video.src.includes('Engraver_2149413.mp4')) {
                this.setPosition(-8.260, -4.915, -4.99);
                this.setRotation(-1.612, 1.127, 1.612);
                this.setScale(0.00755, 0.0057, 1)
                this.showInSceneVideo(true)
            }
        }
        // view-5-b
        if ((this.roomId === '60db668d37950a94f897bfb3')) {
            if (this.video.src.includes('Engraver_2149413.mp4')) {
                this.setPosition(9, -2.54, -1.43);
                this.setRotation(-1.498, -1.230, -1.5);
                this.setScale(0.00376, 0.0028, 1)
                this.showInSceneVideo(true)
            }
            if (this.video.src.includes('Enameler_2149387.mp4')) {
                this.setPosition(9, -2.5, 5.94);
                this.setRotation(-1.5, -1.1, -1.485);
                this.setScale(0.0037, 0.0028, 1)
                this.showInSceneVideo(true)

            }
        }
        // view-2-c
        if ((this.roomId === '6213ed730b6a1d285d429e55')) {
            if (this.video.src.includes('Jeweler_Gemsetter_2149428.mp4')) {
                this.setPosition(-4.670, -2.420, -2.620);
                this.setRotation(-1.612, 1.157, 1.612);
                this.setScale(0.004, 0.003, 1)
                this.showInSceneVideo(true)
            }
            if (this.video.src.includes('Guillocheur_2149414.mp4')) {
                this.setPosition(-4.070, -2.010, -8.090);
                this.setRotation(-1.612, 1.157, 1.612);
                this.setScale(0.003, 0.0025, 1)
                this.showInSceneVideo(true)
            }
        }
        // view-2-a
        if ((this.roomId === '6213ed350b6a1d285d429e4a')) {
            if (this.video.src.includes('Guillocheur')) {
                this.setPosition(-3.360, -1.720, 1.710);
                this.setRotation(-1.612, 1.157, 1.612);
                this.setScale(0.003, 0.0022, 1)
                this.showInSceneVideo(true)
            }
            if (this.video.src.includes('Jeweler_Gemsetter_2149428.mp4')) {
                this.setPosition(-3.580, -1.810, 7.250);
                this.setRotation(-1.662, 1.137, 1.612);
                this.setScale(0.003, 0.0023, 1)
                this.showInSceneVideo(true)
            }
        }
        // view-2-b
        if ((this.roomId === '60db662637950a94f897bfb2')) {
            if (this.video.src.includes('29858Guillocheur.mp4')) {
                this.setPosition(-2.710, -1.410, 2.74);
                this.setRotation(-1.612, 1.157, 1.612);
                this.setScale(0.24, 0.18, 1)
                this.showInSceneVideo(true)
            }
            if (this.video.src.includes('41211Gemsetter.mp4')) {
                this.setPosition(-3.140, -1.485, -1.500);
                this.setRotation(-1.652, 1, 1.65);
                this.setScale(0.245, 0.19, 1)
                this.showInSceneVideo(true)

            }
        }
        // sales-area-2-a
        if ((this.roomId === '608b35939ab97c255a2aabae')) {
            if (this.video.src.includes('VAC_Pop_3_models.mp4')) {
                this.setPosition(2.430, 0.130, 9.160);
                this.setRotation(0, 3.047, 0);
                this.setScale(0.028, 0.015, 1)
                this.showInSceneVideo(true)

            }
        }
        // sales-area-2-a
        if ((this.roomId === '60db682a37950a94f897bfbc')) {
            if (this.video.src.includes('VAC_Pop_3_models.mp4')) {
                this.setPosition(-7.760, 0.130, 8.240);
                this.setRotation(0, -2.910, -0.060);
                this.setScale(0.035, 0.031, 1)
                this.showInSceneVideo(true)
            }
        }

    }

    showInSceneVideo = (muted = true) => {
        this.video.addEventListener("loadeddata", () => {
            this.plane.visible = true;
            this.video.muted = muted;
            this.video.play();
        })
    }

    setPosition(x, y, z) {
        this.plane.position.set(x, y, z);
    }

    setRotation(x, y, z) {
        this.plane.rotation.x = x;
        this.plane.rotation.y = y;
        this.plane.rotation.z = z;
    }

    setScale(x, y, z) {
        this.plane.scale.x = x;
        this.plane.scale.y = y;
        this.plane.scale.z = z;
    }

    play() {
        this.video.play();
        this.plane.visible = true;
        if (this.imageUrl) {
            this.image.visible = false;
        }
    }

    pause() {
        this.video.pause();
    }

    end() {
        this.plane.visible = false;
        if (this.imageUrl) {
            this.image.visible = true;
        }
        if (this.onVideoEnd) {
            this.onVideoEnd();
        }
    }

    isPlaying() {
        return !this.video.paused;
    }

    isVisible() {
        return this.plane.visible;
    }
}
